/**
 * @generated SignedSource<<6bf0e1a50f8992ea9d07f341c336c62c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type watchContentHeaderTemplateDataContentFragment$data = {
  readonly metadata: {
    readonly sourceTemplateEntityId: string | null;
  };
  readonly " $fragmentType": "watchContentHeaderTemplateDataContentFragment";
};
export type watchContentHeaderTemplateDataContentFragment$key = {
  readonly " $data"?: watchContentHeaderTemplateDataContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"watchContentHeaderTemplateDataContentFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "watchContentHeaderTemplateDataContentFragment",
  "selections": [
    {
      "concreteType": "ContentMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "sourceTemplateEntityId"
        }
      ]
    }
  ],
  "type": "Content"
};

(node as any).hash = "ef4f3064f901b2dcf745ba396c56f142";

export default node;
